/**
 * Skazka Theme Configuration
 * This file defines the specific theme settings for the Skazka vendor
 * Updated with variables from Figma design
 */

import { ThemeConfig } from "./types";

export const skazkaTheme: ThemeConfig = {
  name: "Skazka",
  colors: {
    // Primary colors
    primary: "#0099DA",
    primary50: "#2B75D0",
    primary100: "#2060AE",
    primary_light: "rgba(0, 153, 218, 0.25)",
    primary_lighter: "#CAEFF5",
    secondary: "#80C342",

    // Common colors
    transparent: "rgba(0,0,0,0)",
    white: "#FFFFFF",
    black: "#424242",
    dark: "#000000",

    // Background colors
    bg_gray: "#F6F6F6",

    // Gray variations
    gray: "#CDCDCD",
    gray_selected: "#F4F4F4",
    border_gray: "#EDEDED",
    light_gray: "#E6E6E6",
    text_gray: "#848789",

    // Button specific colors
    buttonText: "#FFFFFF",
    buttonHover: "#2B75D0",
    buttonActive: "#2060AE",

    // Filled button colors (from Figma)
    buttonBg: "#0099DA", // Primary blue from Figma
    buttonBgHover: "#2B75D0", // Light blue variant from Figma
    buttonBgActive: "#2060AE", // Darker blue for active state
    buttonBgDisabled: "#CDCDCD", // Gray for disabled state

    // Outlined button colors
    buttonOutlinedBorder: "#0099DA", // Primary blue
    buttonOutlinedBorderHover: "#2B75D0",
    buttonOutlinedBorderActive: "#2060AE",
    buttonBorderDisabled: "#CDCDCD",
    buttonOutlinedText: "#0099DA", // Primary blue
    buttonOutlinedTextHover: "#2B75D0",
    buttonOutlinedTextActive: "#2060AE",
    buttonOutlinedTextDisabled: "#CDCDCD",

    // Tooltip colors
    tooltipBackground: "#FFFFFF",
    tooltipText: "#424242",

    // Modal styles
    modalBackdrop: "rgba(1, 13, 28, 0.75)",
    modalBackdropFilter: "blur(6px)",
    modalMarginLeft: "20px",
    modalMarginRight: "20px",
    modalMarginTop: "139px",
    modalMarginBottom: "auto",

    // Status colors
    success: "#4FB23E",
    error: "#EF1111",
    warning: "#FFE81B",
    info: "#0099DA",
    danger: "#FF7A00",
    yellow: "#FFE81B",
  },
  typography: {
    fontFamily: "Cera Round Pro, sans-serif",
    fontSize: {
      little: "7px",
      small: "8px",
      base: "10px",
      base_xl: "12px",
      base_l: "14px",
      base_x: "16px",
      large: "18px",
    },
  },
  borderRadius: {
    small: "3px",
    middle: "15px",
    big: "50px",
  },
  shadows: {
    popup: "0px 0px 9px rgba(0, 0, 0, 0.2)",
  },
  interfaceElements: ["qrCode"],
};
